import React from 'react'

import ScreenContainer from 'components/ScreenContainer'

import { STRING } from 'resources'

import { RedeemSuccessContainer, Content, RedeemSuccessTitle, TitleButtonSection } from './styles'

const RedeemSocialShareHeader = () => (
  <RedeemSuccessContainer>
    <Content>
      <ScreenContainer>
        <TitleButtonSection>
          <RedeemSuccessTitle>{STRING.wallet.redemptions.socialShare.title}</RedeemSuccessTitle>
        </TitleButtonSection>
      </ScreenContainer>
    </Content>
  </RedeemSuccessContainer>
)

export default RedeemSocialShareHeader
